/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class MinimizedWorkFlowForBaseVersion extends models.WorkFlowDefinitionsBase {
    getFixupPrototypeFunction() { return MinimizedWorkFlowForBaseVersion.fixupPrototype; }

    static newInstance(model: Partial<MinimizedWorkFlowForBaseVersion>): MinimizedWorkFlowForBaseVersion {
        let obj = Object.assign(new MinimizedWorkFlowForBaseVersion(), model);
        MinimizedWorkFlowForBaseVersion.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<MinimizedWorkFlowForBaseVersion>): MinimizedWorkFlowForBaseVersion {
        if (!model) return null;
        return MinimizedWorkFlowForBaseVersion.newInstance(<MinimizedWorkFlowForBaseVersion> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: MinimizedWorkFlowForBaseVersion) {
        if (!obj) return;

        models.MinimizedWorkFlowForBaseVersion.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: MinimizedWorkFlowForBaseVersion): boolean {
        if (models.WorkFlowDefinitionsBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, MinimizedWorkFlowForBaseVersion.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Owners of the workflow.
     */
    owners: Array<string>;

}
